export const getDollarKardex = (currencies) =>
  Object.values(currencies).find((curr) => curr.id === 2)?.exchangeRate || 0;
export const getDollarZcot = (currencies) =>
  Object.values(currencies).find((curr) => curr.id === 3)?.exchangeRate || 0;
